// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Code generated by Microsoft (R) AutoRest Code Generator.
// Changes may cause incorrect behavior and will be lost if the code is regenerated.

import type { PagedAsyncIterableIterator } from "@azure/core-paging";
import type {
  SecurityRule,
  DefaultSecurityRulesListOptionalParams,
  DefaultSecurityRulesGetOptionalParams,
  DefaultSecurityRulesGetResponse,
} from "../models/index.js";

/// <reference lib="esnext.asynciterable" />
/** Interface representing a DefaultSecurityRules. */
export interface DefaultSecurityRules {
  /**
   * Gets all default security rules in a network security group.
   * @param resourceGroupName The name of the resource group.
   * @param networkSecurityGroupName The name of the network security group.
   * @param options The options parameters.
   */
  list(
    resourceGroupName: string,
    networkSecurityGroupName: string,
    options?: DefaultSecurityRulesListOptionalParams,
  ): PagedAsyncIterableIterator<SecurityRule>;
  /**
   * Get the specified default network security rule.
   * @param resourceGroupName The name of the resource group.
   * @param networkSecurityGroupName The name of the network security group.
   * @param defaultSecurityRuleName The name of the default security rule.
   * @param options The options parameters.
   */
  get(
    resourceGroupName: string,
    networkSecurityGroupName: string,
    defaultSecurityRuleName: string,
    options?: DefaultSecurityRulesGetOptionalParams,
  ): Promise<DefaultSecurityRulesGetResponse>;
}
